import { withRequestResponseLog } from 'acquirer/common/infra'
import { RAV_API_ENDPOINT } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientRav = withRequestResponseLog(
  httpClientFactory({
    baseURL: RAV_API_ENDPOINT(),
    responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
  })
)
